import React from "react";
import { motion } from "motion/react";
import { PlayIcon } from "@heroicons/react/solid";
import { useSelector } from "react-redux";
import { handleWarning } from "Helper";

const ComponentNonN = ({
  datavideoList = [],
  handleClickCamera,
  handleClick,
}) => {
  const valueCamera = useSelector((state) => state.playback.valueCamera);
  // console.log(datavideoList, "datavideoList");
  // console.log(valueCamera, 'valueCamera')
  // console.log(datavideoList, 'datavideoList')
  // console.log(datavideoList, "isi datavideoList dari redux");
  // console.log(dataPlayback, "isi dataPlayback setelah di-sort");
  return (
    <div>
      {datavideoList?.length !== 0 ? (
        <ul className="space-y-3">
          {datavideoList.map((item, index) => {
            const isPlayingFile = valueCamera?.videoPath === item?.videoPath;
            // console.log(item, "item");
            return (
              <li
                key={item?.id}
                className="flex items-center justify-between cursor-pointer p-1"
                onClick={() => {
                  if (item?.processStatus === "COMPLETED") {
                    handleClickCamera(item);
                  }else{
                    handleWarning(`${item?.nama_video} Masih Dalam Prosses`)
                  }
                }}
                // onClick={() => handleClickCamera(item)}
              >
                <span className="text-sm text-mo-text">
                  {index + 1}. {item?.nama_video || "Unknown Device"}
                </span>

                <div className="flex">
                  {isPlayingFile && (
                    <span className="italic text-xs text-yellow-400 me-1 flex items-center">
                      Playing
                    </span>
                  )}
                  <motion.div
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                    // style={box}
                  >
                    <PlayIcon
                      className={`h-5 text-mo-button ${isPlayingFile && "text-yellow-400"}`}
                    />
                  </motion.div>
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="text-sm w-full text-center">Video Kosong</div>
      )}
    </div>
  );
};

export default ComponentNonN;
